import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { ROUTES } from 'utils/utils';

export default class PassordResetCode410 extends Component {
    constructor(props) { super(props); }
    render() {
        const { service } = this.props;
        return (
            <div style={{ textAlign: 'center', fontStyle: 'italic', fontWeight: 'bold' }}>
                <span style={{ fontSize: '20px' }}>
                    {'Reset link has expired.'}
                </span>
                <div style={{ fontSize: '12px', fontWeight: 'normal', marginTop: '3px' }}>
                    {'Please request a new passord reset link.'}
                </div>
                <div style={{ margin: '20px 0px 0px 0px' }}>
                    <Link to={ROUTES.ROOT}>
                        <Button
                            icon='home'
                            size='small'
                            onClick={service}
                            style={{ width: '200px', borderRadius: '20px' }}
                        >
                            {'Home'}
                        </Button>
                    </Link>
                </div>
            </div>
        );
    }
}
